// node modules
import React, { FC, Fragment } from 'react';
import { observer } from 'mobx-react';
// ui-library
import {
  Table,
  TableBody,
  TableHead,
} from '@upstox/upstox-ui';
// modules
import OptionChain from 'modules/OptionChain';
// utils
import { getUniqueKey } from '../utils';
// components
import OptionChainTableHeader from './OptionChainTableHeader';
import OptionChainRow from './OptionChainRow';
// typings
import { Props } from './typings';
// styles
import * as css from './styles';

const OptionChainTable: FC<Props> = props => {
  const { dataId, type } = props;
  const tableData = OptionChain.getOptionChainData(type);

  return (
    <Fragment>
      <Table>
        <TableHead css={css.callPutTableHeader}>
          <OptionChainTableHeader type={type} />
        </TableHead>
        <TableBody>
          {tableData.map((item) => {
            const uniqueKey = getUniqueKey(item);
            return (
              <OptionChainRow
                key={uniqueKey}
                item={item}
                type={type}
                dataId={dataId}
              />
            );
          })}
        </TableBody>
      </Table>
    </Fragment>
  );
};

export default observer(OptionChainTable);
